import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const BannedKeywordRBAC = {
  pageID: '3bd07ef509bb635676eefec64ca9b471',
  elementID: {
    ViewBannedKeywordList: 'e15b26dabf18350b615dfd45a2d1798a',
    EditBannedKeyword: 'e15ae2d8cc18350b615dfd4586f33365',
    CreateBannedKeyword: 'e73182b99ca7e7fe470c67e6ccfcffc1',
    DeleteBannedKeyword: '3d47269d14a7e7fe470c7d7252d41960',
  },
} as const

export const useRBACBannedKeywordPage = createUseRBAC(BannedKeywordRBAC.elementID)

export type UseRBACBannedKeywordPageType = ReturnType<typeof useRBACBannedKeywordPage>
